import React from 'react';

interface FretSelectorProps {
  frets: number;
  setFrets: (frets: number) => void;
  maxFrets?: number;
  showFretNumbers: boolean;
  setShowFretNumbers: (show: boolean) => void;
}

const FretSelector: React.FC<FretSelectorProps> = ({ 
  frets, 
  setFrets, 
  maxFrets = 24,
  showFretNumbers,
  setShowFretNumbers
}) => {
  return (
    <div className="space-y-4">
      <div className="form-control">
        <label className="label">
          <span className="label-text">Number of Frets:</span>
          <span className="label-text-alt">{frets}</span>
        </label>
        <input
          type="range"
          min="0"
          max={maxFrets}
          value={frets}
          className="range"
          step="1"
          onChange={(e) => setFrets(parseInt(e.target.value))}
        />
        <div className="w-full flex justify-between text-xs px-2">
          <span>0</span>
          <span>{maxFrets}</span>
        </div>
      </div>
      <div className="form-control">
        <label className="label cursor-pointer">
          <span className="label-text">Show Fret Numbers</span>
          <input
            type="checkbox"
            className="toggle"
            checked={showFretNumbers}
            onChange={(e) => setShowFretNumbers(e.target.checked)}
          />
        </label>
      </div>
    </div>
  );
};

export default FretSelector;